//Constants for ACCOUNT_SELECTION
export const ACCOUNT_SELECTION_REQUEST = 'ACCOUNT_SELECTION_REQUEST'
export const ACCOUNT_SELECTION_SUCCESS = 'ACCOUNT_SELECTION_SUCCESS'
export const ACCOUNT_SELECTION_FAIL = 'ACCOUNT_SELECTION_FAIL'


//Constants for ACCOUNT_UPDATION
export const ACCOUNT_UPDATION_REQUEST = 'ACCOUNT_UPDATION_REQUEST'
export const ACCOUNT_UPDATION_SUCCESS = 'ACCOUNT_UPDATION_SUCCESS'
export const ACCOUNT_UPDATION_FAIL = 'ACCOUNT_UPDATION_FAIL'